import React from 'react';
import { useLanguage } from '../../../helpers/language-context';
import { renderHTML } from '../../../helpers/render-html';

const DownloadLogo = () => {
  const { translations } = useLanguage();
  return (
    <section className="bg-[#28357B] text-white">
      <div className="flex flex-col space-y-8 justify-center items-start mx-auto mb-8">
        <div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl" dangerouslySetInnerHTML={renderHTML(translations.about.downloads)} />
        </div>
      </div>
      
      <div className="space-y-4">
        <div className="bg-white text-[#28357B] rounded-lg flex flex-col md:flex-row items-center justify-center p-2 md:p-4 gap-4">
          <div className="bg-gray-100 border-2 border-gray-200 w-48 flex items-center justify-center rounded-lg py-2">
            <img src="/assets/images/logo/kssb.png" alt="Download Icon" className="w-16 h-auto object-contain" />
          </div>
          <div className="grow font-medium">Kumpulan Semesta Sdn. Bhd. Logo</div>
          <div className="flex items-center justify-center">
            <button className="bg-[#28357B] text-white px-4 py-2 rounded-full">{translations.button.download}</button>
          </div>
        </div>

        <div className="bg-white text-[#28357B] rounded-lg flex flex-col md:flex-row items-center justify-center p-2 md:p-4 gap-4">
          <div className="bg-gray-100 border-2 border-gray-200 w-48 flex items-center justify-center rounded-lg py-2">
            <img src="/assets/images/logo/kssb.png" alt="Download Icon" className="w-16 h-auto object-contain" />
          </div>
          <div className="grow font-medium">Kumpulan Semesta Sdn. Bhd. Logo - High Resolutions</div>
          <div className="flex items-center justify-center">
            <button className="bg-[#28357B] text-white px-4 py-2 rounded-full">{translations.button.download}</button>
          </div>
        </div>

        <div className="bg-white text-[#28357B] rounded-lg flex flex-col md:flex-row items-center justify-center p-2 md:p-4 gap-4">
          <div className="bg-gray-100 border-2 border-gray-200 w-48 flex items-center justify-center rounded-lg py-2">
            <img src="/assets/images/logo/kssb.png" alt="Download Icon" className="w-16 h-auto object-contain grayscale" />
          </div>
          <div className="grow font-medium">Kumpulan Semesta Sdn. Bhd. Logo - Grayscale version</div>
          <div className="flex items-center justify-center">
            <button className="bg-[#28357B] text-white px-4 py-2 rounded-full">{translations.button.download}</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadLogo;
